import { NAV_ITEMS_MODE } from "@/constants";
import { MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS } from "./constants";

const DashboarPlatFormdModule = ({ registerNavItems }) => {
  registerNavItems(NAV_ITEMS_MODE.MSP, MSP_NAV_ITEMS);
  // Registered unconditionally; the DASHBOARD_OVERVIEW_CUSTOMER flag carried on
  // the item is resolved reactively by usePrimaryNavItems once Harness is ready.
  registerNavItems(NAV_ITEMS_MODE.CUSTOMER_ADMIN, CUSTOMER_NAV_ITEMS);
};

export { DashboarPlatFormdModule };

export default {};
